// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadPhoto_container__APy8c","form":"UploadPhoto_form__2MjPG"};